// extracted by mini-css-extract-plugin
export default {"modalCard":"ModalCard_modalCard__EtOoM","close":"ModalCard_close__JsNBI"};